function Header() {
    return (
        <header>
            <h1>Weather App <i className="fad fa-cloud-sun-rain"></i></h1>
        </header>
    )
}

export default Header